import backendHttpRequest from "./backendHttpRequest";
import { config } from "../configs/repositoryConfig";
import { convertToQueryString } from "../utilities/httpUtils";

export const getVacancies = async (filteredObject) => {
  const queryString = convertToQueryString(filteredObject);
  const resourceObject = {
    ...config.backendApiSettings.resources.getVacancies,
  };
  const endpoint = resourceObject.endpoint;
  resourceObject.endpoint = `${endpoint}${
    queryString ? `?${queryString}` : ""
  }`;

  return await backendHttpRequest({ resourceObject });
};

export const getVacancyById = async (id) => {
  const resourceObject = {
    ...config.backendApiSettings.resources.getVacancyById,
  };
  resourceObject.endpoint = resourceObject.endpoint.replace(":id", id);

  return await backendHttpRequest({ resourceObject });
};

export const createVacancy = async (body) => {
  const resourceObject = {
    ...config.backendApiSettings.resources.createVacancy,
  };

  return await backendHttpRequest({ resourceObject, body });
};

export const updateVacancy = async (id, body) => {
  const resourceObject = {
    ...config.backendApiSettings.resources.updateVacancy,
  };
  resourceObject.endpoint = resourceObject.endpoint.replace(":id", id);

  return await backendHttpRequest({ resourceObject, body });
};

export const removeVacancy = async (id) => {
  const resourceObject = {
    ...config.backendApiSettings.resources.deleteVacancy,
  };
  resourceObject.endpoint = resourceObject.endpoint.replace(":id", id);

  await backendHttpRequest({ resourceObject });

  return id;
};
